import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { authApi, type UserPreferences } from '../services/api/auth';

const PREFS_KEY = ['auth', 'preferences'] as const;

export function usePreferences() {
  return useQuery({ queryKey: PREFS_KEY, queryFn: () => authApi.getPreferences() });
}

export function useUpdatePreferences() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: UserPreferences) => authApi.updatePreferences(patch),
    onSuccess: (prefs) => qc.setQueryData(PREFS_KEY, prefs),
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: async (v: { currentPassword: string; newPassword: string }) => {
      const res = await authApi.changePassword(v.currentPassword, v.newPassword);
      if (!res.success) {
        throw new Error(res.error || 'Failed to change password');
      }
    },
  });
}
